module.exports = __webpack_public_path__ + "img/hfri.42131355.png";